<template>
  <div class="container py-5">
    <div class="row" v-if="!loading">
      <div class="col-12">
        <button
          class="btn btn-block btn-lg ticket-primary-cta"
          @click="goCart()"
        >
          <b-icon icon="bag-plus" class="mr-2"></b-icon>
          HACER NUEVO PEDIDO
        </button>
        <button
          class="btn btn-success btn-block btn-lg fixed-bottom"
          v-if="
            ticket.paymentStatus != 'ok' &&
            ticket.payment == 'Webpay' &&
            ticket.status != 'Cancelado'
          "
          @click="payTicket()"
          :disabled="loading"
        >
          PAGAR POR WEBPAY
        </button>
        <button
          class="btn btn-success btn-block btn-lg fixed-bottom"
          v-if="
            ticket.paymentStatus != 'ok' &&
            ticket.payment == 'Klap' &&
            ticket.status != 'Cancelado'
          "
          @click="payTicketKlap()"
          :disabled="loading"
        >
          PAGAR POR KLAP
        </button>
        <button
          class="btn btn-success btn-block btn-lg fixed-bottom"
          v-if="
            ticket.paymentStatus != 'ok' &&
            ticket.payment == 'MercadoPago' &&
            ticket.status != 'Cancelado'
          "
          @click="payTicketMercadoPago()"
          :disabled="loading"
        >
          PAGAR POR MERCADOPAGO
        </button>
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-12 col-md-8 mx-auto text-center mt-4 py-5">
        <div class="ticket-loading">
          <div class="ticket-loading__logo-wrap" v-if="info && info.logo">
            <img
              :src="getLogo(info.logo)"
              :alt="info.custom_name || info.name"
              class="ticket-loading__logo"
            />
          </div>
          <div
            class="spinner-border text-success ticket-loading__spinner"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <small class="ticket-loading__eyebrow">
            {{ (info && (info.custom_name || info.name)) || "Preparando tu pedido" }}
          </small>
          <h4 class="mt-3 mb-2">Cargando detalles de tu pedido</h4>
          <p class="text-muted mb-0">
            Estamos consultando estado, productos y datos del local.
          </p>
          <button
            class="mt-4 btn btn-outline-danger"
            @click="load"
            v-if="tid && showReload"
          >
            Reintentar carga
          </button>
        </div>
      </div>
    </div>
    <div class="row d-none">
      <div class="col-12">
        <b-button-group size="sm" class="w-100 mt-4">
          <b-button
            v-for="(btn, idx) in buttons"
            :key="idx"
            :pressed.sync="btn.state"
            variant="primary"
            :disabled="!btn.state"
          >
            {{ btn.caption }}
          </b-button>
        </b-button-group>
      </div>
    </div>
    <div class="row justify-content-center" v-if="ticket.status == 'Pendiente'">
      <div class="col-12 col-md-10 text-center mt-5 alert alert-info py-5">
        <div
          class="spinner-border"
          role="status"
          style="width: 3rem; height: 3rem"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <h4 class="mt-2">Tu pedido fue enviado al local</h4>
        <h6>Esperando confirmacion</h6>
        <small>La pagina se actualizará automaticamente</small>
        <div class="w-100">
          <small class="font-weight-bold"
            >Se ha enviado un correo a tu casilla, te mantendremos
            actualizado.</small
          >
          <small class="text-muted d-block"
            >Puede llegar a correo no deseado</small
          >
        </div>
        <div class="d-none">
          <b-button
            v-if="!ticket.suscription"
            size="sm"
            variant="outline-primary"
            @click="suscribe()"
            >Activar notificaciones</b-button
          >
          <b-button v-else variant="success" size="sm" disabled
            >Notificaciones activadas!</b-button
          >
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div class="row justify-content-center mt-5" v-if="info">
          <div class="col">
            <div class="row" v-if="ticket.status == 'Cancelado'">
              <div class="col-12">
                <div class="alert alert-danger text-center">
                  <h1>:(</h1>
                  Tu pedido rechazado
                  <strong class="d-block">Motivo: {{ ticket.reason }}</strong>
                </div>
              </div>
            </div>
            <div class="row" v-if="ticket.status == 'Aceptado'">
              <div class="col-12">
                <div class="alert alert-success">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-bag-check"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                    />
                    <path
                      d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"
                    />
                  </svg>
                  Tu pedido fue aceptado por el local
                  <strong v-if="ticket.hour">
                    - Entrega aproximada:
                    {{ getAproxHour(ticket.hour) }}</strong
                  >
                </div>
              </div>
            </div>
            <div class="row" v-if="loading == false">
              <div
                class="col-12 py-3"
                v-if="calificationAvailable(ticket) && isQuery()"
              >
                <div class="row border rounded my-2 py-3 bg-white shadow-sm">
                  <div class="col-12 mb-2">
                    <strong class="d-block">CALIFICA TU PEDIDO</strong>
                    <small class="text-muted">
                      Tu opinion ayuda a mejorar proximos pedidos
                    </small>
                  </div>
                  <div class="col-12 mb-3">
                    <b-form-rating
                      v-model="rating"
                      variant="warning"
                      stars="5"
                      show-value
                      no-border
                      :disabled="ratingLoading || ratingSaved"
                    ></b-form-rating>
                  </div>
                  <div class="col-12">
                    <small class="d-block mb-2">COMENTARIO (OPCIONAL)</small>
                    <div class="input-group align-items-stretch">
                      <textarea
                        class="form-control"
                        cols="10"
                        rows="3"
                        v-model="comment"
                        :disabled="ratingLoading || ratingSaved"
                        placeholder="Cuéntanos como fue tu experiencia"
                      ></textarea>
                      <div class="input-group-append">
                        <button
                          class="btn btn-success h-100 px-4 font-weight-bold"
                          :disabled="ratingLoading || ratingSaved || !canSubmitRating"
                          @click="saveRating()"
                        >
                          <span v-if="ratingLoading">
                            <span
                              class="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Enviando...
                          </span>
                          <span v-else-if="ratingSaved">Enviado</span>
                          <span v-else>ENVIAR</span>
                        </button>
                      </div>
                    </div>
                    <small class="text-success d-block mt-2" v-if="ratingSaved">
                      Gracias, tu calificacion fue enviada correctamente.
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-7">
                <div class="ticket-panel ticket-summary">
                  <div class="ticket-summary__eyebrow">
                    Pedido {{ ticket.type.toLowerCase() }}
                  </div>
                  <h4 class="ticket-summary__title">
                    #{{ ticket.number | formatNumber }}
                  </h4>
                  <div v-if="info" class="ticket-summary__store">
                    <strong class="d-block">{{ info.custom_name || info.name }}</strong>
                    <span class="text-muted">{{ info.address }}, {{ info.city }}</span>
                  </div>
                  <div class="ticket-meta">
                    <div class="ticket-meta__item">
                      <small>Cliente</small>
                      <strong>{{ ticket.clientName }}</strong>
                    </div>
                    <div class="ticket-meta__item">
                      <small>Telefono</small>
                      <strong>{{ ticket.phone }}</strong>
                    </div>
                    <div class="ticket-meta__item">
                      <small>Fecha</small>
                      <strong>{{ ticket.createdAt | moment("DD/MM/YY HH:mm") }}</strong>
                    </div>
                    <div class="ticket-meta__item" v-if="ticket.type == 'Domicilio'">
                      <small>Direccion</small>
                      <strong>{{ ticket.address }}</strong>
                    </div>
                    <div class="ticket-meta__item" v-if="ticket.date">
                      <small>Programado</small>
                      <strong>{{ formatScheduledTicketDate(ticket.date, ticket.time) }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="ticket-panel ticket-help mt-3 mt-md-0">
                  <small class="ticket-panel__label">Ayuda con tu pedido</small>
                  <p class="mb-3">
                    Si tienes dudas o quieres cancelar tu pedido debes
                    comunicarte con el local.
                  </p>
                  <a
                    class="btn btn-outline-warning btn-block font-weight-bold"
                    :href="`tel:${info.phone}`"
                  >
                    <b-icon icon="phone" class="mr-2"></b-icon>
                    Llamar {{ info.phone }}
                  </a>
                  <button
                    class="btn btn-success btn-block mt-2"
                    @click="sendToWhatsApp()"
                    v-if="settings.whatsapp"
                  >
                    <b-icon icon="whatsapp" class="mr-2"></b-icon>
                    Enviar por Whatsapp
                  </button>
                </div>
              </div>

              <div
                class="ml-auto col-md-6 col-12 mt-3 d-none"
                v-if="
                  ticket.status == 'Aceptado' &&
                  ticket.payment == 'Transferencia' &&
                  false
                "
              >
                <div class="alert alert-info">
                  <h4>
                    Datos para transferencia por ${{
                      formatNumber(ticket.total)
                    }}
                  </h4>
                  <pre>{{ ticket.bankAccount }}</pre>
                </div>
              </div>

              <div
                class="col-md-12 col mt-3"
                v-if="ticket.status == 'Aceptado' && payment.details"
              >
                <div class="ticket-panel ticket-panel--info">
                  <small class="ticket-panel__label">Medio de pago</small>
                  <h5 class="text-uppercase mb-2">Detalles para {{ payment.name }}</h5>
                  <div v-html="getContent(payment.details)"></div>
                </div>
              </div>

              <div class="col-md-12 col mt-3" v-if="ticket.notes">
                <div class="ticket-panel ticket-panel--notes">
                  <small class="ticket-panel__label">Notas del pedido</small>
                  <div v-html="getContent(ticket.notes)"></div>
                </div>
              </div>

              <div class="col-12">
                <div
                  class="alert alert-success font-weight-bold mt-2"
                  v-if="ticket.paymentStatus == 'ok'"
                >
                  <div class="row align-items-center">
                    <div class="col text-center">
                      <b-icon
                        icon="check-circle"
                        style="width: 30px; height: 20px"
                      />
                      <span class="ml-3 d-inline-block">Pagado en linea</span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-12 mt-4"
                v-if="ticket.flowOrders && ticket.flowOrders.length > 0"
              >
                <div class="row">
                  <div class="col-12">
                    <small class="text-muted">Pagos en linea</small>
                  </div>
                </div>
                <div
                  class="list-group-item"
                  v-for="event in ticket.flowOrders"
                  :key="event._id"
                >
                  <div class="row">
                    <div class="col-4 col-md-2">
                      <strong>{{ event.createdAt | moment("HH:mm") }}</strong>
                    </div>
                    <div class="col">
                      {{ event.status == "ok" ? "Pagado" : "No Pagado" }}
                    </div>
                    <div class="col">#{{ event.order }}</div>
                    <div class="col text-right">
                      <strong>${{ event.total | formatNumber }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4">
                <div class="ticket-panel ticket-order">
                  <div class="ticket-order__header">
                    <small class="ticket-panel__label mb-0">Resumen del pedido</small>
                    <strong>{{ ticket.products.length }} producto<span v-if="ticket.products.length !== 1">s</span></strong>
                  </div>
                  <div
                    class="ticket-item"
                    v-for="p in ticket.products"
                    :key="p._id"
                  >
                    <div class="ticket-item__row">
                      <div class="ticket-item__info">
                        <div class="ticket-item__title">
                          <span class="ticket-item__qty">{{ p.qty }} x</span>
                          <span class="font-weight-bold text-uppercase">{{ p.name }}</span>
                        </div>
                        <small class="d-block text-muted">
                          Valor unitario ${{ formatNumber(p.value) }}
                        </small>
                        <span class="ticket-item__note">{{ p.details || "Sin notas" }}</span>
                      </div>
                      <div class="ticket-item__total">
                        ${{ formatNumber(p.total) }}
                      </div>
                    </div>
                    <div class="ticket-options" v-if="p.options && p.options.length > 0">
                      <div class="ticket-options__label">Opciones</div>
                      <div
                        class="ticket-option"
                        v-for="op in p.options"
                        :key="op._id"
                      >
                        <strong>{{ op.label || op.name }}:</strong>
                        <span v-if="op.values && op.values.length > 0">{{
                          op.values.map((o) => o.name).join(", ")
                        }}</span>
                        <span v-else>{{ op.selected }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="ticket-totals">
                    <div class="ticket-totals__row">
                      <span>Medio de pago</span>
                      <strong>{{ ticket.payment }}</strong>
                    </div>
                    <div class="ticket-totals__row">
                      <span>Sub-total</span>
                      <strong>${{ formatNumber(sub_total) }}</strong>
                    </div>
                    <div
                      class="ticket-totals__row"
                      v-if="ticket.discount"
                    >
                      <span>Descuento</span>
                      <strong>-${{ formatNumber(ticket.discount) }}</strong>
                    </div>
                    <div
                      class="ticket-totals__row"
                      v-if="Number(ticket.deliveryValue) > 0"
                    >
                      <span>Envio</span>
                      <strong>${{ formatNumber(ticket.deliveryValue) }}</strong>
                    </div>
                    <div class="ticket-totals__row ticket-totals__row--grand">
                      <span>Total</span>
                      <strong>${{ formatNumber(ticket.total) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="modal"
      title="Cargando..."
      no-close-on-backdrop
      hide-header
      hide-footer
    >
      <div class="row py-5">
        <div class="col text-center">
          <b-spinner
            variant="success"
            size="xl"
            type="grow"
            label="Spinning"
          ></b-spinner>
          <div class="w-100 py-2"></div>
          Cargando Pago...
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.ticket-primary-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  box-shadow: 0 14px 30px rgba(34, 197, 94, 0.22);
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.ticket-primary-cta:hover,
.ticket-primary-cta:focus {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 18px 34px rgba(34, 197, 94, 0.28);
  filter: saturate(1.05);
}

.ticket-primary-cta:active {
  transform: translateY(0);
  box-shadow: 0 10px 22px rgba(34, 197, 94, 0.2);
}

.ticket-loading {
  padding: 2rem 1.5rem;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #dbe3ef;
  border-radius: 20px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
}

.ticket-loading__logo-wrap {
  width: 112px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  padding: 1rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 16px 30px rgba(15, 23, 42, 0.08);
  animation: ticket-loading-float 2.4s ease-in-out infinite;
}

.ticket-loading__logo {
  max-width: 100%;
  max-height: 64px;
  object-fit: contain;
}

.ticket-loading__spinner {
  width: 2.75rem;
  height: 2.75rem;
}

.ticket-loading__eyebrow {
  display: block;
  margin-top: 1rem;
  color: #16a34a;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ticket-panel {
  background: #fff;
  border: 1px solid #dbe3ef;
  border-radius: 14px;
  padding: 1.25rem;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
}

.ticket-panel__label {
  display: block;
  margin-bottom: 0.5rem;
  color: #6b7280;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ticket-summary__eyebrow {
  color: #3b82f6;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ticket-summary__title {
  margin: 0.15rem 0 0.75rem;
  color: #334155;
  font-size: 2rem;
  font-weight: 800;
}

.ticket-summary__store {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.ticket-meta {
  display: grid;
  gap: 0.85rem;
}

.ticket-meta__item small {
  display: block;
  margin-bottom: 0.15rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ticket-meta__item strong {
  color: #334155;
  font-weight: 700;
}

.ticket-help {
  background: linear-gradient(180deg, #fff8dd 0%, #fffdf5 100%);
  border-color: #f7dea1;
}

.ticket-panel--info {
  background: #eef8ff;
  border-color: #bfe4fb;
}

.ticket-panel--notes {
  background: #f8fafc;
}

.ticket-order__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.ticket-item {
  padding: 1rem 0;
  border-top: 1px solid #edf2f7;
}

.ticket-item:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.ticket-item__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.ticket-item__title {
  margin-bottom: 0.2rem;
  color: #334155;
  font-size: 1rem;
}

.ticket-item__qty {
  margin-right: 0.35rem;
  color: #64748b;
  font-weight: 700;
}

.ticket-item__note {
  display: block;
  margin-top: 0.4rem;
  color: #475569;
}

.ticket-item__total {
  color: #0f172a;
  font-size: 1.1rem;
  font-weight: 800;
  white-space: nowrap;
}

.ticket-options {
  margin-top: 0.85rem;
  padding: 0.85rem 1rem;
  background: #f8fafc;
  border-radius: 10px;
}

.ticket-options__label {
  margin-bottom: 0.5rem;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
}

.ticket-option {
  margin-top: 0.25rem;
  color: #334155;
}

.ticket-option strong {
  margin-right: 0.35rem;
}

.ticket-totals {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #dbe3ef;
}

.ticket-totals__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.45rem 0;
  color: #334155;
}

.ticket-totals__row--grand {
  margin-top: 0.3rem;
  padding-top: 0.9rem;
  border-top: 1px solid #e5e7eb;
  color: #0f172a;
  font-size: 1.1rem;
}

@media (max-width: 767px) {
  .ticket-summary__title {
    font-size: 1.6rem;
  }

  .ticket-loading {
    padding: 1.5rem 1rem;
  }

  .ticket-loading__logo-wrap {
    width: 92px;
    height: 92px;
  }

  .ticket-item__row,
  .ticket-order__header,
  .ticket-totals__row {
    flex-direction: column;
    align-items: flex-start;
  }

    .ticket-item__total {
      margin-top: 0.35rem;
    }
}

@keyframes ticket-loading-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
</style>

<script>
export default {
  data() {
    return {
      showReload: false,
      comment: "",
      rating: 0,
      ratingLoading: false,
      ratingSaved: false,
      ticket: {
        business: {},
      },
      tid: 0,
      loading: true,
      buttons: [
        { caption: "1. Pedido Enviado", state: false },
        { caption: "2. Esperando Respuesta del local", state: true },
        { caption: "3. Confirmacion", state: false },
        { caption: "4. Entrega", state: false },
      ],
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.tid = this.$route.params.id;
    this.load();
    //this.checkPreference()
    this.$gtag.event("view_ticket", {
      event_category: "ticket",
      event_label: "User view ticket",
      value: 1,
    });
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    sub_total() {
      return this.ticket.products.reduce((t, a) => t + a.total, 0);
    },
    settings() {
      return this.info && this.info.settings ? this.info.settings : {};
    },
    payment() {
      const payments = Array.isArray(this.settings.payments) ? this.settings.payments : [];
      return (
        payments.find((p) => {
          return p.name == this.ticket.payment;
        }) || {}
      );
    },
    canSubmitRating() {
      return this.rating > 0 || this.comment.trim() !== "";
    },
  },
  methods: {
    normalizeScheduleTime(value) {
      if (value === -1 || value === "-1" || value === null || value === undefined) {
        return -1;
      }

      if (typeof value === "string" && value.includes(":")) {
        const [hour, minute] = value.split(":").map(Number);
        if (Number.isNaN(hour) || Number.isNaN(minute)) return -1;
        return hour * 60 + minute;
      }

      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return -1;
      if (numericValue >= 0 && numericValue <= 23) return numericValue * 60;
      return numericValue;
    },
    formatScheduledTicketDate(date, time) {
      const scheduledAt = this.$moment(date);
      const minutes = this.normalizeScheduleTime(time);

      if (minutes >= 0) {
        scheduledAt
          .hour(Math.floor(minutes / 60))
          .minutes(minutes % 60);
      }

      return scheduledAt.format("dddd DD [de] MMMM [-] HH:mm");
    },
    checkPreference() {
      const { preference_id } = this.$route.query;

      if (!preference_id) return console.log("no preference");

      console.log("preference_id", preference_id);

      this.$http
        .get(`mercadopago/${preference_id}`)
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sendToWhatsApp() {
      let msg = `Hola, mi nombre es *${this.ticket.clientName}*\n`;
      msg += `Pedido para *${this.ticket.type}*.\n`;
      msg += `🎫 Numero de pedido: #${this.ticket.number}\n\n`;
      msg += `Mi pedido es:\n`;
      msg += "-".repeat(30) + "\n";

      this.ticket.products.forEach((p) => {
        msg += `✅ *${p.qty} x ${p.name}* | $${p.total}\n`;
        // if (p.options) {
        //   p.options.forEach((op) => {
        //     msg += `  - ${op.label}: ${op.selected}\n`;
        //   });
        // }
        if (p.details) msg += `  - Notas: ${p.details}\n`;
      });
      msg += `\n💲 *Total: $${this.ticket.total}*\n`;
      msg += `📱 Telefono: +56${this.ticket.phone}\n`;
      if (this.ticket.type != "Retiro")
        msg += `🗺️ Direccion: ${this.ticket.address}\n`;
      let date = this.$moment(this.ticket.createdAt).format("DD/MM/YY");
      msg += `📅 Fecha: ${date}\n`;
      if (this.ticket.hour) msg += `⌚ Hora: ${this.ticket.hour}\n`;
      msg += `Medio de pago: ${this.ticket.payment}\n`;
      msg += `Notas: ${this.ticket.notes || "Sin notas"}\n`;
      msg += `\n\n`;

      let phone = this.settings.whatsapp;
      window.open(
        `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
          msg
        )}`,
        "_blank"
      );
    },
    isQuery() {
      let token = this.ticket.createdAt.slice(-4);
      if (token == this.$route.query.s) return true;
      return false;
    },
    saveRating() {
      if (!this.canSubmitRating || this.ratingLoading || this.ratingSaved) return;

      this.ratingLoading = true;
      let tid = this.ticket._id;
      this.$http
        .post(`account/ticket/${tid}/rating`, {
          note: this.rating,
          comment: this.comment,
        })
        .then(() => {
          this.ratingSaved = true;
          this.ticket.rating = {
            note: this.rating,
            comment: this.comment,
          };
        })
        .catch(() => {
          this.$swal({
            title: "Error al guardar, intente nuevamente",
          });
        })
        .finally(() => {
          this.ratingLoading = false;
        });
    },
    payTicket() {
      this.$refs["modal"].show();
      this.$http
        .post(`${this.ticket._id}/flow`)
        .then((res) => {
          let data = res.data.data;
          console.log("ta listo");
          window.location.href = `${data.url}?token=${data.token}`;
        })
        .catch((err) => {
          alert("Error al cargar el pago");
          this.$refs["modal"].hide();
          console.error(err);
          // setTimeout(() => {
          //   this.loading = false;
          // }, 10000);
        });
    },
    payTicketKlap() {
      this.$refs["modal"].show();
      this.$http
        .post(`${this.ticket._id}/klap`)
        .then((res) => {
          let data = res.data;
          console.log("ta listo", data);
          window.location.href = `${data.redirect_url}`;
        })
        .catch((err) => {
          alert("Error al cargar el pago");
          this.$refs["modal"].hide();
          console.error(err);
          // setTimeout(() => {
          //   this.loading = false;
          // }, 10000);
        });
    },
    payTicketMercadoPago() {
      this.$refs["modal"].show();
      const url = window.location.href.split("?")[0];
      this.$http
        .post(`${this.ticket._id}/mercadopago`, {
          url,
        })
        .then((res) => {
          let data = res.data;
          console.log("ta listo");
          window.location.href = data.init_point;
        })
        .catch((err) => {
          //alert("Error al cargar el pago");
          this.$swal({
            title: "Error al cargar el pago",
          });
          this.$refs["modal"].hide();
          console.error(err);
          // setTimeout(() => {
          //   this.loading = false;
          // }, 10000);
        });
      console.log("mercado pago");
    },
    cutEmail() {
      let email = this.ticket.email;
      let a = email.indexOf("@");
      let r = email.slice(a, a - 3);
      return email.replace(r, "****");
    },
    getContent(content) {
      return content
        .replaceAll("\n", "<br>")
        .replaceAll(
          '<a href="',
          '<a class="font-weight-bold" target="_blank" href="'
        );
    },
    getAproxHour() {
      let time = parseInt(this.settings.deliveryTime);
      let hour = this.$moment(this.ticket.hour, "HH:mm");
      if (!time || this.ticket.type == "Retiro")
        return `${hour.format("HH:mm")}`;
      return `${hour.format("HH:mm")} - ${hour
        .add(time, "minutes")
        .format("HH:mm")}`;
    },
    goCart() {
      this.$cookies.remove("ticketId");
      if (this.settings.style == "delivery")
        this.$router.push(this.getLink("menu"));
      else this.$router.push(this.getLink("productos"));
    },
    // suscribe() {
    //   if (!("Notification" in window)) {
    //     return alert(
    //       "Este navegador no es compatible con las notificaciones de escritorio"
    //     );
    //   }
    //   this.nstatus = Notification.permission;
    //   Notification.requestPermission(() => {
    //     this.nstatus = Notification.permission;
    //     navigator.serviceWorker
    //       .register("/worker.js", {
    //         scope: "/",
    //       })
    //       .then((register) => {
    //         // console.log(register);
    //         return register.pushManager.subscribe({
    //           userVisibleOnly: true,
    //           applicationServerKey: this.$store.state.PVK,
    //         });
    //       })
    //       .then((suscription) => {
    //         this.nstatus = Notification.permission;
    //         return this.$http.post(`ticket/${this.tid}/suscribe`, {
    //           s: JSON.stringify(suscription),
    //         });
    //       })
    //       .then(() => {
    //         this.load();
    //       })
    //       .catch(() => {
    //         alert("Error intente nuevamente");
    //       });
    //   }).catch(() => {
    //     alert("Error intente nuevamente");
    //   });
    // },
    load() {
      this.showReload = false;
      
      this.$http
        .get("ticket/" + this.tid)
        .then((res) => {
          this.ticket = res.data.data;
          this.ratingSaved = !!(
            this.ticket.rating &&
            (this.ticket.rating.note || this.ticket.rating.comment)
          );
          if (this.ratingSaved) {
            this.rating = this.ticket.rating.note || 0;
            this.comment = this.ticket.rating.comment || "";
          }

          if (
            this.ticket.payment == "Klap" &&
            this.ticket.paymentStatus != "ok"
          ) {
            //this.payTicketKlap();
          }

          this.$http.get(res.data.data.b).then((res2) => {
            this.$store.commit("setInfo", res2.data.data);
          });
          if (this.ticket.status == "Pendiente") setTimeout(this.load, 60000);

          this.loading = false;
        })
        .catch(() => {
          // alert("ERROR");
          this.showReload = true;
        });
    },
  },
  watch: {
    info() {
      document.title = `Ticket - ${this.info.custom_name || this.info.name}`;
    },
  },
};
</script>
